import { toast } from "react-toastify";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, XCircle } from "lucide-react";
import orderServices from "../../api-service/order-service";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
export const BrowseProducts = ({ params, t, className }: any) => {
  return (
    <Link to={`/branches/${params.branch_id}`}>
      <button className={`bg-primary text-onPrimary px-5 py-2.5 md:px-6 md:py-3 rounded-xl font-semibold text-sm md:text-base hover:bg-primary/90 active:scale-95 shadow-md hover:shadow-lg transition-all duration-300 ${className || ""}`}>
        {t("gloabl.browseProducts")}
      </button>
    </Link>
  );
};

export const CheckoutComponent = ({
  cartItems,
  total,
  t,
  params,
  loadCart,
}: any) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const items = cartItems.map((item: any) => ({
    product_id: item.id,
    amount: item.amount,
    sub_option_id: item.option
      ? item.option.map((opt: any) => opt.subOption.id)
      : [],
    note: item.note || "",
  }));
  // const navigate = useNavigate();

  // التحقق من صحة الرقم الإماراتي (يبدأ بـ 05 وله 10 أرقام)
  const isValidPhoneNumber = (phone: string) => {
    // يجب أن يبدأ بـ 05 وأن يكون طوله 10 أرقام (05XXXXXXXXX)
    const phoneRegex = /^05[0-9]{8}$/;
    return phoneRegex.test(phone);
  };

  // معالج تغيير رقم الهاتف (يسمح فقط بالأرقام)
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // إزالة أي شيء غير الأرقام
    // الحد الأقصى 10 أرقام (05XXXXXXXXX)
    if (value.length <= 10) {
      setPhone(value);
    }
  };

  // تنظيف الرقم قبل الإرسال (حذف الـ 0 في البداية إن وُجد)
  const formatPhoneForAPI = (phone: string): string => {
    let cleanedPhone = phone;
    // إذا بدأ بـ 0، نحذفه
    if (cleanedPhone.startsWith("0")) {
      cleanedPhone = cleanedPhone.substring(1);
    }
    return cleanedPhone;
  };
  const handleCheckout = async () => {
    if (!name || !phone) {
      toast.error(
        <div className="flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-destructive flex-shrink-0" />
          <span className="font-semibold text-destructive">{t("gloabl.phoneOrName")}</span>
        </div>,
        {
          className: "!bg-card !border-2 !border-destructive/50 !rounded-xl !shadow-xl !backdrop-blur-sm",
          bodyClassName: "!text-destructive !font-semibold",
          progressClassName: "!bg-destructive",
          hideProgressBar: false,
        }
      );
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      toast.error(
        <div className="flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-destructive flex-shrink-0" />
          <span className="font-semibold text-destructive">{t("gloabl.phoneInvalid")}</span>
        </div>,
        {
          className: "!bg-card !border-2 !border-destructive/50 !rounded-xl !shadow-xl !backdrop-blur-sm",
          bodyClassName: "!text-destructive !font-semibold",
          progressClassName: "!bg-destructive",
          hideProgressBar: false,
        }
      );
      return;
    }

    try {
      const table_id = sessionStorage.getItem("tableId");
      orderServices
        .storeOrder({
          items: items,
          note: note,
          table_id: table_id || 1,
          branch_id: params.branch_id,
          nameCustomer: name,
          phoneCustomer: `971${formatPhoneForAPI(phone)}`, // إضافة 971 قبل الرقم وحذف الـ 0 في البداية إن وُجد
          // success_url: `${origin}/branches/${params.branch_id}/orders?confirm_payment=true`,
          // cancel_url: `${origin}/branches/${params.branch_id}/cart`,
          success_url: `${origin}/${params.branch_id}/orders?confirm_payment=true`,
          cancel_url: `${origin}/${params.branch_id}/cart`,
        })
        .then((res) => {
          window.location.href = res.data.url;
          setName("");
          setPhone("");
          setNote("");
          localStorage.removeItem(`cart${params.branch_id}`);
          loadCart();
          window.dispatchEvent(new Event("cart-updated"));
        })
        .catch((err) => {
          toast.error(
            <div className="flex items-center gap-3">
              <XCircle className="w-5 h-5 text-destructive flex-shrink-0" />
              <span className="font-semibold text-destructive">{t("gloabl.orderError")}</span>
            </div>,
            {
              className: "!bg-card !border-2 !border-destructive/50 !rounded-xl !shadow-xl !backdrop-blur-sm",
              bodyClassName: "!text-destructive !font-semibold",
              progressClassName: "!bg-destructive",
              hideProgressBar: false,
            }
          );
        });
    } catch (error) {
      toast.error(
        <div className="flex items-center gap-3">
          <XCircle className="w-5 h-5 text-destructive flex-shrink-0" />
          <span className="font-semibold text-destructive">{t("gloabl.orderError")}</span>
        </div>,
        {
          className: "!bg-card !border-2 !border-destructive/50 !rounded-xl !shadow-xl !backdrop-blur-sm",
          bodyClassName: "!text-destructive !font-semibold",
          progressClassName: "!bg-destructive",
          hideProgressBar: false,
        }
      );
    }
  };
  return (
    <div className="flex flex-col gap-5 md:gap-6 p-5 md:p-6 bg-gradient-to-br from-card to-background rounded-2xl border-2 border-border/50 shadow-lg">
      {/* Customer Info */}
      <div className="space-y-4">
        <h3 className="text-xl md:text-2xl font-bold text-foreground border-b-2 border-primary/20 pb-3">
          {t("gloabl.orderDetails")}
        </h3>

        <div className="space-y-3">
          <input
            type="text"
            placeholder={t("contact.name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-3 md:py-3.5 border-2 border-border rounded-xl bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-300"
          />

          {/* Phone Input with UAE prefix */}
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-1 text-muted-foreground font-medium pointer-events-none z-10">
              <span dir="ltr" className="text-sm md:text-base">+971</span>
            </div>
            <input
              type="text"
              inputMode="numeric"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="05XXXXXXXXX"
              maxLength={10}
              dir="ltr"
              className="w-full pl-16 pr-4 py-3 md:py-3.5 border-2 border-border rounded-xl bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-300"
            />
          </div>

          <textarea
            placeholder={t("gloabl.addNote")}
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full px-4 py-3 md:py-3.5 border-2 border-border rounded-xl bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary resize-none transition-all duration-300"
          ></textarea>
        </div>
      </div>

      {/* Total Price */}
      <div className="flex items-center justify-between p-4 md:p-5 bg-gradient-to-r from-primary/10 to-primary/5 rounded-xl border-2 border-primary/20">
        <p className="text-lg md:text-xl font-bold text-foreground">
          {t("gloabl.totalPrice")}:
        </p>
        <p className="flex items-center gap-1.5 text-xl md:text-2xl font-bold text-primary">
          <UAEDirhamIcon className="w-5 h-5 md:w-6 md:h-6" />
          {total.toFixed(2)}
        </p>
      </div>

      {/* Checkout Button */}
      <button
        onClick={() => handleCheckout()}
        type="button"
        className="w-full text-onPrimary bg-primary rounded-xl hover:bg-primary/90 active:scale-[0.98] focus:ring-4 focus:outline-none focus:ring-primary/50 font-bold text-base md:text-lg px-5 py-3.5 md:py-4 text-center shadow-lg hover:shadow-xl transition-all duration-300"
      >
        {t("gloabl.checkout")}
      </button>

    </div>
  );
};
